/* global dataLayer */

/* eslint-disable import/first */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getResourcePath, withClientConfig } from '@spotahome/soyuz/client';

import { getAllCities } from '@gqlClient/queries/cities';

import Homepage from './components/Homepage';

import '../../common/scss/init.scss';

const PRELOAD_FONTS = [
  'https://sah-public-assets.s3-eu-west-1.amazonaws.com/fonts/Gotham-Bold.woff',
  'https://sah-public-assets.s3-eu-west-1.amazonaws.com/fonts/Gotham-Book.woff',
  'https://sah-public-assets.s3-eu-west-1.amazonaws.com/fonts/icons/spotahome-family-Regular.woff'
];

const getFontPreload = () =>
  PRELOAD_FONTS.map(font => ({
    rel: 'preload',
    href: getResourcePath(font),
    as: 'font',
    crossOrigin: 'anonymous'
  }));

class LandingPageContainer extends Component {
  static NAME = 'LandingPageName';

  static contextTypes = {
    data: PropTypes.object,
    locales: PropTypes.object
  };

  static async requestHeaders() {
    return {
      links: getFontPreload()
    };
  }

  static async requestData(req, _, { graphqlClient, clientConfig }) {
    try {
      const availableCities = Object.keys(clientConfig.enabledCities).filter(
        key => clientConfig.enabledCities[key]
      );

      const citiesResponse = await getAllCities(graphqlClient)();
      const { allCities } = citiesResponse.data;
      return {
        data: {
          cityList: allCities
            .filter(city => availableCities.includes(city.id))
            .sort((a, b) => (a.id > b.id ? 1 : -1)),
          userId: req.userId
        }
      };
    } catch (err) {
      console.log(err);
    }

    return {
      data: {
        cityList: [],
        userId: null
      }
    };
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      ...(context.data[LandingPageContainer.NAME] || {})
    };
  }

  componentDidMount() {
    const { userId } = this.state;
    if (userId && typeof dataLayer !== 'undefined') {
      dataLayer.push({ userId });
    }
  }

  render() {
    const { cityList, userId } = this.state;
    return <Homepage cityList={cityList} userId={userId} />;
  }
}

export default withClientConfig()(LandingPageContainer);
